<template>
  <div class="py-4 container-fluid">
    <div class="row mb-3">
      <div class="col-12 d-flex flex-wrap justify-content-between align-items-center">
        <div>
          <h5 class="mb-0">{{ $t('reports.assetRoiTitle') }}</h5>
          <p class="mb-0 text-sm text-secondary">{{ $t('reports.assetRoiSubtitle') }}</p>
        </div>
        <material-button variant="outline" color="dark" size="sm" :disabled="!rows.length" @click="onExport">
          <i class="material-icons text-sm me-1">download</i>{{ $t('reports.exportCsv') }}
        </material-button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-secondary" role="status"></div>
        </div>
        <template v-else>
          <el-table :data="rows" stripe>
            <el-table-column prop="toolName" :label="$t('reports.tool')" min-width="160" />
            <el-table-column prop="toolType" :label="$t('reports.toolType')" min-width="120" />
            <el-table-column :label="$t('reports.ageMonths')" align="center" min-width="100">
              <template #default="{ row }">{{ row.ageMonths ?? '–' }}</template>
            </el-table-column>
            <el-table-column :label="$t('reports.purchasePrice')" align="right" min-width="120">
              <template #default="{ row }">{{ row.purchasePrice != null ? money(row.purchasePrice) : '–' }}</template>
            </el-table-column>
            <el-table-column :label="$t('reports.lifetimeRevenue')" align="right" min-width="130">
              <template #default="{ row }">{{ money(row.lifetimeRevenue) }}</template>
            </el-table-column>
            <el-table-column :label="$t('reports.paybackRatio')" align="center" min-width="120">
              <template #default="{ row }">
                <span v-if="row.paybackRatio != null" class="badge" :class="row.paybackRatio >= 1 ? 'bg-gradient-success' : 'bg-gradient-secondary'">
                  {{ row.paybackRatio.toFixed(2) }}×
                </span>
                <span v-else>–</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="d-flex justify-content-end mt-3">
            <el-pagination v-model:current-page="currentPage" :page-size="pageSize" :total="totalItems" layout="prev, pager, next" @current-change="fetchData" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import MaterialButton from "@/components/MaterialButton.vue";
import { exportCsv } from "../../utils/csvExport";

export default {
  name: "AssetRoiReport",
  components: { MaterialButton },
  data() {
    return {
      rows: [],
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      loading: true,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    money(v) {
      return `${new Intl.NumberFormat("is-IS").format(Math.round(v || 0))} kr.`;
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await api.get("/Analytics/Tools/AssetRoi", {
          params: { currentPage: this.currentPage, pageSize: this.pageSize },
        });
        this.rows = response.data.result || [];
        this.totalItems = response.data.totalItems || 0;
      } catch (e) {
        console.error("AssetRoiReport fetchData error:", e); // eslint-disable-line no-console
        this.$toast.error(this.$t("common.unableToRetrieveData"), { timeout: 0 });
      } finally {
        this.loading = false;
      }
    },
    onExport() {
      const columns = [
        { key: "toolName", label: this.$t("reports.tool") },
        { key: "toolType", label: this.$t("reports.toolType") },
        { key: "ageMonths", label: this.$t("reports.ageMonths") },
        { key: "purchasePrice", label: this.$t("reports.purchasePrice") },
        { key: "lifetimeRevenue", label: this.$t("reports.lifetimeRevenue") },
        { key: "paybackRatio", label: this.$t("reports.paybackRatio") },
      ];
      exportCsv("asset-roi", columns, this.rows);
    },
  },
};
</script>
